import { configure, observable, runInAction, makeObservable } from 'mobx';
import { observer, Provider } from 'mobx-react';
import * as React from 'react';
import { Polyline } from 'react-google-maps';

import Loading from '../Shared/Loading';
import MapMarker from './components/MapMarker';
import SimpleMap from './components/SimpleMap';
import Timeline from './components/Timeline';

import { ILine } from './models/line';
import { IPlace } from './models/place';
import { ITargetPlace } from './models/targetPlace';
import UiStore from './stores/UiStore';

import './styles';

configure({ isolateGlobalState: true });

interface IAccessUI {
  targetPlace: ITargetPlace;
}

@observer
class AccessUI extends React.Component<IAccessUI, any> {

  @observable ui: UiStore = new UiStore();

  constructor(props: IAccessUI) {
    super(props);
    makeObservable(this);
    runInAction(() => {
      const { targetPlace } = this.props;
      this.ui.mapCenter = { lat: targetPlace.latitude, lng: targetPlace.longitude };
      this.ui.targetPlace = targetPlace;
    });
  }

  componentDidMount() {
    const { targetPlace } = this.ui;
    if (targetPlace != null) {
      this.ui.orderOrigins(targetPlace, () => {
        this.ui.updateAccess({ origin_id: this.ui.currentOrigin.place_id, dest_id: targetPlace.place_id });
      });
    }
  }

  render() {
    // ヘッダーのスキー場検索マップがレンダリングされた後、こちらの操作をするとGoogleMpasのエラーが出る。
    // GoogleMapsは後にレンダリングされた方が優先されるようなので、isLoadingを使って再レンダリングしている。
    // KNOW ISSUE:
    // モーダルを閉じられただけでは再検索しないので、スキー場検索の後に、Timelineの地名をクリックしても反応しない。
    const apiKey = process.env.GOOGLE_MAPS_API_KEY;
    return (
      <Provider ui={this.ui}>
        <div className="access-ui-container">
          <Loading isLoading={this.ui.isLoading} />
          <div className="access-ui__timeline">
            <Timeline />
          </div>
          {!this.ui.isLoading &&
            <SimpleMap
              loadingElement={<div className="access-ui__fill access-ui__map-loading"></div>}
              containerElement={<div className="access-ui__map access-ui__fill" />}
              mapElement={<div className="access-ui__fill" />}
              center={this.ui.mapCenter}
            >
              {this.ui.durationInHour &&
                <div className="access-ui__meta">{this.ui.t.hour({hour: this.ui.durationInHour})}</div>
              }
              {this.renderOrigin()}
              {this.renderTargetPlace()}
              {this.renderRoutes()}
            </SimpleMap>
          }
        </div>
      </Provider>
    );
  }

  public renderRoutes() {
    const { access, placeOpenIndex } = this.ui;
    if (access == null) { return null; }
    const { duration, path } = access;
    if (path == null || path.length === 0) { return null; }

    const result = [];
    path.forEach((line: ILine, i) => {
      const { origin, dest } = line;
      if (!origin || !dest) { return; }
      const originToDest = [{ lat: origin.latitude, lng: origin.longitude }, { lat: dest.latitude, lng: dest.longitude }];
      const polyLineOptions = {
        strokeColor: '#007bff',
        strokeWeight: 4,
      };
      result.push(
        <React.Fragment key={origin.place_id}>
          <MapMarker
            iconType="dot"
            isOpen={i === placeOpenIndex}
            handleClick={() => {}}
            place={origin}
          />
          <Polyline key={originToDest.map(p => p.lat).join('-')} path={originToDest} options={polyLineOptions} />
        </React.Fragment>
      );
    });
    return result;
  }

  public renderTargetPlace() {
    const { targetPlace } = this.ui;
    return (
      <MapMarker
        isOpen={false}
        handleClick={() => {}}
        key={targetPlace.place_id}
        place={{ latitude: targetPlace.latitude, longitude: targetPlace.longitude } as IPlace}
      />
    );
  }

  public renderOrigin() {
    const { currentOrigin } = this.ui;
    return (
      <MapMarker
        iconType="dot"
        isOpen={false}
        handleClick={() => {}}
        key={currentOrigin.place_id}
        place={currentOrigin}
      />
    );
  }

}

export default AccessUI;
